export default class Validator {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return !!(value.match(/^([A-HJ-NP-Z])?[1-9][0-9]{3}([A-Z]{3})?$/i));
    }
}
